import { Component, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { TagsService } from 'src/app/services/tags.service';
import { SettingsService } from 'src/app/services/settings.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { UserTradesService } from 'src/app/services/user-trades.service';
import { UserService } from 'src/app/services/user.service';
import { LookupBanks } from 'src/app/shared/models/general/lookup-banks';
import { NewTransaction } from 'src/app/shared/models/transactions/new-transaction';
import { UserFiaPins } from 'src/app/shared/models/users/user-fia-pins';
import { UserTradingSearchRequest } from 'src/app/shared/models/users/user-trading-search-request';
import { UserTradingSearchResponse } from 'src/app/shared/models/users/user-trading-search-response';
import { formatDate } from '@angular/common';
import { UserTradingBankAccount } from 'src/app/shared/models/users/user-trading-bank-account';
import { UserFullDetails } from 'src/app/shared/models/users/user-full-details';
import { UserProfile } from 'src/app/shared/models/users/user-profile';
import { HttpErrorResponse } from '@angular/common/http';
import { Reason } from 'src/app/shared/models/users/reason';
import { Tag } from 'src/app/shared/models/general/tag';
import { Error } from 'src/app/shared/models/general/error';
import { SavedTradesResponse } from 'src/app/shared/models/transactions/saved-trades-response';
import { PrebookingTradeResponse } from 'src/app/shared/models/transactions/prebooking-trades-response';
import { InvalidTradesResponse } from 'src/app/shared/models/transactions/invalid-trades-response';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrebookingTrade } from 'src/app/shared/models/transactions/prebooking-trade';

@Component({
  selector: 'app-trade-planning',
  templateUrl: './trade-planning.component.html',
  styleUrls: ['./trade-planning.component.scss'],
})
export class TradePlanningComponent implements OnInit {
  @ViewChild('userFiaPinModal', { static: true }) userFiaPinModal: any;
  @ViewChild('bookTradesResponseModal', { static: true })
  bookTradesResponseModal: any;
  @ViewChild('cfsCheckClients', { static: true }) cfsCheckClients: any;

  busy: boolean = true;
  processTradesBusy: boolean = false;
  processTradesProgress: number = 0;
  errorResponse: HttpErrorResponse;
  modalBusy: boolean = true;
  showError: boolean = false;
  errorMsg: string = 'Oops! Looks like something went wrong, please contact support if this issue persists';

  userTradingSearchRequest: UserTradingSearchRequest = new UserTradingSearchRequest();

  tagFilter: Tag[] = [];
  selectedTagFilterId: number = 0;
  readonly TagId = Tag.Id;

  showExcludedUsersOptions: { Id: number; Name: string; Value: boolean }[] = [
    { Id: 0, Name: 'Yes', Value: true },
    { Id: 1, Name: 'No', Value: false },
  ];

  tradeFilter: { name: string }[] = [
    {
      name: 'Non-discretionary',
    },
    {
      name: 'Discretionary',
    },
    {
      name: 'Possible Deposits',
    },
    {
      name: 'All',
    },
  ];

  usersOrderBy: { Id: number; Name: string }[] = [
    { Id: 0, Name: 'Last trade ASC' },
    { Id: 1, Name: 'Last trade DESC' },
    // { Id: 2, Name: "Arb rate ASC" },
    //{ Id: 3, Name: "Arb rate DESC" },
    { Id: 4, Name: 'Full name' },
    //{ Id: 5, Name: 'Suggested trade amount ASC' },
    { Id: 6, Name: 'Suggested trade amount DESC' },
    //{ Id: 7, Name: 'SDA available ASC' },
    { Id: 8, Name: 'SDA available DESC' },
    //{ Id: 9, Name: 'FIA available ASC' },
    { Id: 10, Name: 'FIA available DESC' },
    //{ Id: 11, Name: 'FIA pin balance ASC' },
    { Id: 12, Name: 'FIA pin balance DESC' },
    //{ Id: 11, Name: 'Possible Trades ASC' },
    { Id: 13, Name: 'Possible Trades DESC' },
  ];

  usersAccountBalanceDates: { Id: number; Name: string }[] = [
    { Id: 0, Name: 'Today' },
    { Id: 1, Name: 'Yesterday' },
    { Id: 1, Name: 'Last 7 days' },
  ];

  arbFacilitatorAvailableBalance: number;
  arbFacilitatorAvailableBalanceRemaining: number;

  userTradingSearchResponse: UserTradingSearchResponse[] = [];
  userIdList: number[] = [];

  tradesToProcess: NewTransaction[] = [];
  savedTradesSuccessful: PrebookingTradeResponse[] = [];
  savedTradesFailed: PrebookingTradeResponse[] = [];
  savedTradesInvalid: InvalidTradesResponse[] = [];

  selectedTrade: UserTradingSearchResponse = new UserTradingSearchResponse();
  selectedTradeTotalTradeAmount: number = 0;
  selectedTradeToProcess: NewTransaction = new NewTransaction();
  selectedPossibleTradeEdit: boolean = false;
  selectedUserProfile: UserProfile = new UserProfile();
  selectedUserFullDetails: UserFullDetails = new UserFullDetails();

  activeTags: Tag[] = [];

  totalTradesValue: number = 0;
  totalTradesValueDifference: number = 0;
  selectedTradeTotalAmount: number = 0;
  selectedTradeAmountRemaining: number = 0;

  latestBankBalanceDate: Date = new Date(1900, 1, 1, 0, 0);
  currentUserLatestBankAccount: UserTradingBankAccount;

  validationMessage: string = '';
  showValidationMessage: boolean = false;
  allowSave: boolean = false;
  warningsAcknowledged: boolean = false;
  //Modals
  showUserProfileModal: boolean = false;

  constructor(
    public settingsService: SettingsService,
    public userTradesService: UserTradesService,
    public transactionService: TransactionService,
    public modalService: NgbModal,
    public userService: UserService,
    private tagService: TagsService
  ) {
    this.busy = true;
    this.settingsService.ValidateGlobalVars().then(() => {
      this.SetupUserTradingSearchRequest();
      this.SearchPossibleUserTrades();
    });
  }

  ngOnInit(): void {
    this.subscribeToTagsRefreshStream();
    this.SetupUserTradingSearchRequest();
    setInterval(() => {
      this.GetArbFacilitatorAvailableTradeBalance();
    }, 300 * 1000);
  }

  originalSearchResponse: UserTradingSearchResponse[] = [];
  public filterByTagId() {
    if (this.selectedTagFilterId === 0) {
      this.userTradingSearchResponse = [...this.originalSearchResponse];
      return;
    }

    this.userTradingSearchResponse = this.originalSearchResponse.filter((x) => {
      return x.tags.some((tag) => tag.id === this.selectedTagFilterId);
    });
  }

  private SetupUserTradingSearchRequest() {
    this.userTradingSearchRequest.entityType = this.settingsService.brokerEntity.id;
    this.userTradingSearchRequest.entityId = this.settingsService.brokerUsers[0].brokerId;
    this.userTradingSearchRequest.orderBy = this.usersOrderBy[0].Name;
    this.userTradingSearchRequest.bankId = new LookupBanks().GetBankById(7).id; // Capitec
  }

  private ResetVars() {
    this.tradesToProcess = [];
    this.savedTradesFailed = [];
    this.savedTradesInvalid = [];
    this.savedTradesSuccessful = [];

    this.userTradingSearchResponse = [];
    this.userIdList = [];
    this.selectedTrade = new UserTradingSearchResponse();
    this.selectedTradeTotalTradeAmount = 0;
    this.selectedTradeToProcess = new NewTransaction();
    this.selectedPossibleTradeEdit = false;

    this.totalTradesValue = 0;
    this.totalTradesValueDifference = 0;
  }

  SearchPossibleUserTrades() {
    this.busy = true;
    this.ResetVars();
    this.userTradesService.SearchPossibleUserTrades(this.userTradingSearchRequest).subscribe(
      (response) => {
        this.originalSearchResponse = response;
        this.userTradingSearchResponse = response;
        this.userIdList = this.userTradingSearchResponse.map((x) => x.userId);
        this.FillTagFilter();
        this.DecideBookAsStandard();
        this.CalculateBankBalanceDate();
        this.GetArbFacilitatorAvailableTradeBalance();
        this.busy = false;
        this.showError = false;
      },
      (error) => {
        this.showError = true;
        if (error.error.ErrorDetail) {
          this.errorMsg = error.error.ErrorDetail;
        } else {
          this.errorMsg = 'Unable to get the latest trades, please try again later..';
        }

        this.busy = false;
      }
    );
  }

  FillTagFilter() {
    this.tagService.GetAllTags().subscribe({
      next: (tagFilterList: Tag[]) => {
        this.tagFilter = [];
        const allTag = new Tag();
        allTag.id = 0;
        allTag.name = 'All';
        this.tagFilter.push(allTag);
        this.tagFilter.push(...tagFilterList);
      },
      error: (error) => {
        this.errorMsg = `Failed to fill tag filter list -  ${Error.InterpretErrorMessage(error)}`;
        this.showError = true;
      },
    });
  }

  DecideBookAsStandard() {
    this.userTradingSearchResponse.forEach((element) => {
      if (element.ShouldBookAsStandard()) {
        element.bookAsStandard = true;
      }
    });
  }

  CalculateBankBalanceDate() {
    this.userTradingSearchResponse.forEach((element) => {
      var currentDate = new Date(element.accountBalanceDate);
      if (currentDate >= this.latestBankBalanceDate) {
        this.latestBankBalanceDate = currentDate;
      }
    });
  }

  GetArbFacilitatorAvailableTradeBalance() {
    this.transactionService.GetAvailableBalances(1).subscribe(
      (response) => {
        this.arbFacilitatorAvailableBalance = response;
        this.arbFacilitatorAvailableBalanceRemaining = this.arbFacilitatorAvailableBalance;
      },
      (error) => {
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
      }
    );
  }

  GetSelectedTradeUserLatestLargestBankBalance() {
    // TODO: LDF make this async

    this.userService.GetLatestBankBalance(this.selectedTrade.userId).subscribe(
      (response) => {
        this.currentUserLatestBankAccount = response;

        var balanceDate = new Date(this.currentUserLatestBankAccount.balanceDate);
        if (balanceDate > this.selectedTrade.accountBalanceDate) {
          //console.log('Updating bank balance to ' + this.currentUserLatestBankAccount.balance);
          this.selectedTrade.accountBalance = this.currentUserLatestBankAccount.balance;
          this.selectedTrade.accountBalanceDate = this.currentUserLatestBankAccount.balanceDate;
        } else {
          console.log('Balance date is too old ' + balanceDate.toDateString());
          //console.log(this.currentUserLatestBankAccount);
        }
      },
      (error) => {
        console.log('Error getting latest balance for user');
        console.log(error);
      }
    );
  }

  ProcessSelectedTrades() {
    this.busy = true;
    this.bookTradesResponseModal.show();
    const newTransactions: NewTransaction[] = [];
    this.tradesToProcess.forEach((trade) => {
      newTransactions.push(trade);
    });

    this.transactionService.NewTransactions(newTransactions).subscribe(
      (response: SavedTradesResponse) => {
        response.failedToSaveTrades?.forEach((failed) => {
          failed.trade.pinsAsText = this.showPinsAsText(failed.trade.userFiaPins);
          failed.trade.strippedCautionMessage = this.stripCaution(failed.trade.message);
          failed.trade.shouldShowBadge = this.shouldShowBadge(failed.trade);
          this.savedTradesFailed.push(failed);
        });
        response.savedTrades?.forEach((successful) => {
          successful.trade.pinsAsText = this.showPinsAsText(successful.trade.userFiaPins);
          this.savedTradesSuccessful.push(successful);
        });
        response.invalidTrades?.forEach((invalid) => {
          invalid.trade.pinsAsText = this.showPinsAsText(invalid.trade.userFiaPins);
          this.savedTradesInvalid.push(invalid);
        });
        this.busy = false;
        this.showError = false;
      },
      (error) => {
        console.log(error);
        this.bookTradesResponseModal.hide();
        this.busy = false;
        this.errorResponse = error;
        this.showError = true;
      }
    );
  }

  // TODO: Clean up commented out code at a later stage

  /*
  onPossibleUserTradeCheckBoxChange(trade: UserTradingSearchResponse) {
    if (!trade.selected) {
      this.onPossibleUserTradeCheck(trade);
    }
    else {
       this.onPossibleUserTradeUncheck(trade);
    }
  }

  onPossibleUserTradeCheck(trade: UserTradingSearchResponse) {
    this.selectTrade(trade);
    this.showUserFiaPinModal(false);
  }

  onPossibleUserTradeUncheck(trade: UserTradingSearchResponse) {
    this.clearPossibleTradesForUser(trade.userId);
    this.deselectTrade(trade);    
    this.CalculateTotalAmountSelectedTrades();    
  }

  clearPossibleTradesForUser(userId: number) {
    var tradeToRemoveIndex = this.tradesToProcess.findIndex(x => x.userId == userId);
    if (tradeToRemoveIndex != -1) {
      this.tradesToProcess.splice(tradeToRemoveIndex, 1);
    }

    if (this.tradesToProcess.length == 0) {
      this.tradesToProcess = [];
    }
  }

  selectTrade(trade: UserTradingSearchResponse) {
    this.selectedTrade = trade;
    this.selectedTrade.selected = true;
  }

  deselectTrade(trade: UserTradingSearchResponse) {
    // do we really need to do this? is it because angular is always mapping data to these referenced objects?
    trade.overriddenAccountBalance = 0;
    trade.overrideAccountBalance = false;
    trade.userFiaPins.forEach(pin => {
      this.ClearPinAmount(pin);
    });
    this.selectedTrade = new UserTradingSearchResponse();    

    // but why?
    this.selectedPossibleTradeEdit = false;
  }

  isEditingMode(trade: UserTradingSearchResponse) {
    if (this.findTradeToProcess(trade) == null) {
      return false;
    }
    
    return true;
  }
/*
  onUserFiaPinModalSaveClicked() {
    console.log("onUserFiaPinModalSaveClicked");
    if (this.selectedPossibleTradeEdit) {

      this.selectedTradeToProcess.sdaAmount = this.selectedTrade.sdaAmount;
      this.selectedTradeToProcess.SDATrade = this.selectedTradeToProcess.sdaAmount > 0 ? true : false;

      this.initializeInvalidPins(this.selectedTrade.userFiaPins);
      this.selectedTradeToProcess.userFiaPins = this.selectedTrade.userFiaPins;
      this.selectedTradeToProcess.fiaAmount = this.selectedTrade.userFiaPins.reduce((sum: number, b: UserFiaPins) => sum + b.transactionUsedAmount, 0);
      
      this.selectedTradeToProcess.tradeAmount = this.selectedTradeToProcess.fiaAmount + this.selectedTradeToProcess.sdaAmount;

      this.selectedTradeToProcess.overrideAccountBalance = this.selectedTrade.overrideAccountBalance;
      this.selectedTradeToProcess.overriddenAccountBalance = this.selectedTrade.overriddenAccountBalance;
      
      this.updateUserTradingSearchResponse(true, this.selectedTrade.suggestedTradeAmount);
      
      var tradeToEditIndex = this.tradesToProcess.findIndex(x => x.userId == this.selectedTrade.userId);
      if (tradeToEditIndex != -1) {
        this.tradesToProcess[tradeToEditIndex] = this.selectedTradeToProcess;
      }

      /*
      if (this.currentSection == 'SDA') {
        this.selectedPossibleTrade.SDATrade = true;
        this.selectedPossibleTrade.sdaAmount = this.selectedTrade.suggestedTradeAmount;
        this.selectedPossibleTrade.tradeAmount = this.selectedTrade.suggestedTradeAmount;
        this.updateUserTradingSearchResponse(true, this.selectedTrade.suggestedTradeAmount)
      }
      else {
        this.selectedPossibleTrade.SDATrade = false;
        this.selectedTrade.userFiaPins.forEach(x => {
          if (x.transactionUsedAmount == null || x.transactionUsedAmount == undefined) {
            x.transactionUsedAmount = 0;
          }
        });

        this.selectedPossibleTrade.userFiaPins = this.selectedTrade.userFiaPins;
        this.selectedPossibleTrade.fiaAmount = this.selectedTrade.userFiaPins.reduce((sum: number, b: UserFiaPins) => sum + b.transactionUsedAmount, 0);
        // probably have to update this to add sda amounts
        this.selectedPossibleTrade.tradeAmount = this.selectedPossibleTrade.fiaAmount;
        this.selectedPossibleTrade.overrideAccountBalance = this.selectedTrade.overrideAccountBalance;
        this.selectedPossibleTrade.overriddenAccountBalance = this.selectedTrade.overriddenAccountBalance;
        this.updateUserTradingSearchResponse(true, this.selectedPossibleTrade.fiaAmount)
      }

      var tradeToEditIndex = this.possibleUserTrades.findIndex(x => x.userId == this.selectedTrade.userId);
      if (tradeToEditIndex != -1) {
        this.possibleUserTrades[tradeToEditIndex] = this.selectedPossibleTrade;
      }
      */
  /*
    }
    else {
      var newTrade: NewTransaction = this.createNewTransaction();
      this.tradesToProcess.push(newTrade);
      this.selectedTrade.selected = true;
      this.updateUserTradingSearchResponse(true, this.selectedTrade.suggestedTradeAmount);
    }

    this.CalculateTotalAmountSelectedTrades();
    this.hideUserFiaPinModal();
  }
*/
  /*
  onUserFiaPinModalCancelClicked() {
    console.log("onUserFiaPinModalCancelClicked");
    if (!this.selectedPossibleTradeEdit) {
      this.updateUserTradingSearchResponse(false, this.selectedTrade.suggestedTradeAmount);
      
      this.deselectTrade(this.selectedTrade);
      this.selectedTrade.selected = false;
    }
    this.CalculateTotalAmountSelectedTrades();
    this.hideUserFiaPinModal();
  }

  initializeInvalidPins(userFiaPins: UserFiaPins[]) {
    console.log("initializeInvalidPins");
    userFiaPins.forEach(x => {
      if (x.transactionUsedAmount == null || x.transactionUsedAmount == undefined) {
        x.transactionUsedAmount = 0;
      }
    });
  }
*/

  saveNewTransaction(newTransaction: NewTransaction) {
    //console.log("saveNewTransaction");

    newTransaction.overrideAccountBalance = this.selectedTrade.overrideAccountBalance;
    newTransaction.overriddenAccountBalance = this.selectedTrade.overriddenAccountBalance;

    newTransaction.overridePips = this.selectedTrade.overridePips;
    newTransaction.pips = this.selectedTrade.pips;

    newTransaction.sdaAmount = this.selectedTrade.sdaAmount > 0 ? this.selectedTrade.sdaAmount : 0;
    newTransaction.userFiaPins = this.selectedTrade.userFiaPins;
    newTransaction.fiaAmount = this.CalculateFiaAmount();
    newTransaction.tradeAmount = this.CalculateTotalTradeAmount();

    newTransaction.selectedBillingType = newTransaction.billingType;

    var tradeToEditIndex = this.tradesToProcess.findIndex((x) => x.userId == this.selectedTrade.userId);
    if (tradeToEditIndex != -1) {
      this.tradesToProcess[tradeToEditIndex] = newTransaction;
    } else {
      this.tradesToProcess.push(newTransaction);
    }

    console.info('NewTransaction saved');
    console.info(newTransaction);
  }

  generateNewTransactionFromSelectedTrade(): NewTransaction {
    //console.log("generateNewTransaction");
    var newTransaction: NewTransaction = new NewTransaction();
    newTransaction.userId = this.selectedTrade.userId;
    newTransaction.fullName = this.selectedTrade.userDetails.fullName;
    newTransaction.arbFacilitatorId = this.selectedTrade.arbFacilitatorId;
    newTransaction.brokerId = this.selectedTrade.brokerId;
    newTransaction.tradeAmountCurrencyId = 95;
    newTransaction.createdByUserId = this.settingsService.user.id;

    return newTransaction;
  }

  OverrideAccBalance() {
    this.selectedTrade.overriddenAccountBalance = this.selectedTrade.accountBalance;
    this.selectedTrade.overrideAccountBalance = true;
  }

  OverridePips() {
    this.selectedTrade.overridePips = true;
  }

  /*
  updateUserTradingSearchResponse(selected: boolean, suggestedTradeAmount: number) {
    console.log("updateUserTradingSearchResponse");
    this.busy = true;
    var tradeIndex = this.userTradingSearchResponse.findIndex(x => x.userId == this.selectedTrade.userId);
    if (tradeIndex != -1) {
      this.userTradingSearchResponse[tradeIndex].selected = selected;
      //this.userTradingSearchResponse[tradeIndex].suggestedTradeAmount = suggestedTradeAmount;
    }
    this.busy = false;
  }

  showUserFiaPinModal(editing: boolean = false) {
    console.log("showUserFiaPinModal");
    this.modalBusy = false;

    if (editing == false) {
      this.CalculateTotalTradeAmount();
      if (this.selectedTrade.userFiaPins.length >= 1) {
        this.selectedTrade.userFiaPins.forEach(pin => {
          this.FillPinAmount(pin);
        });
      } 
      else {
        this.FillSdaAmount();
      }
    }
    else {
      this.CalculateTotalTradeAmount();
    }
    
    this.userFiaPinModal.show();
  }

  hideUserFiaPinModal() {
    console.log("hideUserFiaPinModal");
    this.modalBusy = true;
    this.selectedTradeTotalTradeAmount = 0;
    this.totalTradesValueDifference = 0;
    this.selectedTrade = new UserTradingSearchResponse();
    this.selectedPossibleTradeEdit = false;
    this.userFiaPinModal.hide();
  }
*/
  /*
  EditUserTransaction(trade: UserTradingSearchResponse) {
    console.log("EditUserTransaction");
    this.selectedPossibleTradeEdit = true;
    this.selectedTrade = trade;

    // refactor this? just worried about if it's not found
    var tradeToEditIndex = this.tradesToProcess.findIndex(x => x.userId == trade.userId);
    if (tradeToEditIndex != -1) {
      this.selectedTradeToProcess = this.tradesToProcess[tradeToEditIndex];
    }

    this.showUserFiaPinModal(this.selectedPossibleTradeEdit);
  }

  findTradeToProcess(trade: UserTradingSearchResponse): NewTransaction  {
    var tradeToEditIndex = this.tradesToProcess.findIndex(x => x.userId == trade.userId);
    if (tradeToEditIndex != -1) {
      return this.tradesToProcess[tradeToEditIndex];
    }

    return null;
  }

  FillPinAmount(pin: UserFiaPins){
    console.log("FillPinAmount");
    var selectedPinIndex = this.selectedTrade.userFiaPins.findIndex(x=>x.id == pin.id);
    if(selectedPinIndex != -1){
      if(this.totalTradesValueDifference > 0 && this.totalTradesValueDifference > this.selectedTrade.userFiaPins[selectedPinIndex].pinBalance ){
        this.selectedTrade.userFiaPins[selectedPinIndex].transactionUsedAmount = pin.pinBalance;
      }
      else if(this.selectedTrade.userFiaPins[selectedPinIndex].pinBalance >= this.totalTradesValueDifference){
        this.selectedTrade.userFiaPins[selectedPinIndex].transactionUsedAmount = this.totalTradesValueDifference;
      }

      this.CalculateTotalTradeAmount();
    }
  }

  ClearPinAmount(pin: UserFiaPins) {
    console.log("ClearPinAmount");
    var selectedPinIndex = this.selectedTrade.userFiaPins.findIndex(x=>x.id == pin.id);

    if(selectedPinIndex != -1){
      this.selectedTrade.userFiaPins[selectedPinIndex].transactionUsedAmount = 0;
      this.CalculateTotalTradeAmount();
    }
  }

  FillSdaAmount() {
    console.log("FillSdaAmount");
    if (this.totalTradesValueDifference > 0 ) {
      if (this.selectedTrade.sdaAvailable > this.totalTradesValueDifference) {
        this.selectedTrade.sdaAmount = this.totalTradesValueDifference;
      }
      else {
        this.selectedTrade.sdaAmount = this.selectedTrade.sdaAvailable;
      }

      this.CalculateTotalTradeAmount();
    }
  }

  ClearSdaAmount() {
    console.log("ClearSdaAmount");
    this.selectedTrade.sdaAmount = 0;
    this.CalculateTotalTradeAmount();
  }

  CalculateTotalTradeAmount() {
    console.log("CalculateTotalTradeAmount");
    this.selectedTradeTotalTradeAmount = this.selectedTrade.userFiaPins.reduce((sum: number, b: UserFiaPins) => sum + b.transactionUsedAmount, 0);
    console.log((this.selectedTradeTotalTradeAmount));
    if (this.selectedTrade.sdaAmount > 0) {
      console.log((this.selectedTrade.sdaAmount));
      this.selectedTradeTotalTradeAmount += this.selectedTrade.sdaAmount;
    }
    console.log((this.selectedTradeTotalTradeAmount));
    console.log((this.selectedTrade.suggestedTradeAmount));
    this.totalTradesValueDifference = this.selectedTrade.suggestedTradeAmount - this.selectedTradeTotalTradeAmount;
    console.log((this.selectedTrade));
    console.log((this.selectedTradeToProcess));
    console.log((this.selectedPossibleTradeEdit));
  }

  CalculateTotalAmountSelectedTrades() {
    console.log("CalculateTotalAmountSelectedTrades");
    this.totalTradesValue = this.tradesToProcess.reduce((sum: number, b: NewTransaction) => sum + b.tradeAmount, 0);
  }
  */

  displayError(error: string): string {
    this.showValidationMessage = true;
    this.validationMessage = error;

    return this.validationMessage;
  }

  clearError() {
    this.showValidationMessage = false;
    this.validationMessage = '';
  }

  allowedToSave() {
    if (this.allowSave && this.warningsAcknowledged) {
      return true;
    }
    if (this.hasWarnings() === false) {
      return true;
    }
    return false;
  }

  ValidateTradeBreakdown(selectedTrade: UserTradingSearchResponse): string {
    //console.log('Validation:' + this.selectedTradeTotalAmount);

    this.allowSave = false;
    this.clearError();

    if (this.selectedTradeTotalAmount == 0) {
      return 'AwaitingUserInput';
    }

    if (selectedTrade.sdaAmount < 0) {
      return this.displayError('SDA cannot be less than 0');
    }

    if (selectedTrade.userFiaPins.length >= 5) {
      let countPinsUsed = 0;
      //console.log(selectedTrade.userFiaPins);
      selectedTrade.userFiaPins.forEach((pin) => {
        //console.log(pin.transactionUsedAmount);
        if (pin.transactionUsedAmount > 0) {
          countPinsUsed++;
        }
      });

      //console.log(countPinsUsed);
      if (countPinsUsed > 4) {
        return this.displayError("You shouldn't use more than 4 pins");
      }

      if (countPinsUsed > 3 && selectedTrade.sdaAmount > 0) {
        return this.displayError(`You shouldn't use SDA with more than 3 pins`);
      }
    }

    if (this.isAnyPinUsedAmountNegativeOrOverPinValue()) {
      return this.displayError("Pin amounts cannot be less than 0 or more than the pin's available amount");
    }

    if (selectedTrade.overridePips && (selectedTrade.pips < 100 || selectedTrade.pips > 550)) {
      return this.displayError("Pips can't be less than 100 or larger than System Default");
    }

    var bankBalance = this.CalculateBankBalance();
    // to avoid using the full amount avilable, leaving a safe buffer of 500
    bankBalance -= 500;

    if (this.selectedTradeTotalAmount > bankBalance) {
      return this.displayError('Not enough funds');
    }

    var fiaAmount = this.CalculateFiaAmount();
    var sdaAmount = selectedTrade.sdaAmount;

    if (fiaAmount > selectedTrade.fiaAvailable || sdaAmount > selectedTrade.sdaAvailable) {
      return this.displayError('Total FIA / SDA amount exceeds available FIA / SDA');
    }

    if (this.selectedTradeTotalAmount < 100000) {
      // this doesn't block saving but just not recommended
      this.allowSave = true;
      return this.displayError('Trade is less than R 100 000. That seems like a teriible idea');
    }

    // all good then
    this.clearError();
    this.allowSave = true;

    return '';
  }

  Extract(filename: string) {
    class PossibleTrade {
      constructor(
        public UserId: number,
        public FullName: string,
        public SuggestedTradeAmount: number,
        public AccountBalance: number,
        public SDAAvailable: number,
        public FIAAvailable: number,
        public FIAPinBalance: number,
        public Ratio: string,
        public ArbRate: number,
        public LastTradeDate: Date,
        public TradeReason: string,
        public PreferredMinArbRate: number,
        public MaxTradeAmount: number,
        public SpouseId?: number,
        public SpouseFullName?: string,
        public SpouseAccBalance?: number
      ) {
        this.UserId = UserId;
        this.FullName = FullName;
        this.SuggestedTradeAmount = SuggestedTradeAmount;
        this.AccountBalance = AccountBalance;
        this.SDAAvailable = SDAAvailable;
        this.FIAAvailable = FIAAvailable;
        this.FIAPinBalance = FIAPinBalance;
        this.Ratio = Ratio;
        this.ArbRate = ArbRate;
        this.LastTradeDate = LastTradeDate;
        this.TradeReason = TradeReason;
        this.PreferredMinArbRate = PreferredMinArbRate;
        this.SpouseId = SpouseId;
        this.SpouseFullName = SpouseFullName;
        this.SpouseAccBalance = SpouseAccBalance;
        this.MaxTradeAmount = MaxTradeAmount;
      }
    }

    var possibleTrades: PossibleTrade[] = [];
    this.userTradingSearchResponse.forEach((x) => {
      var possibleT: PossibleTrade = new PossibleTrade(
        x.userDetails.id,
        x.userDetails.fullName,
        x.suggestedTradeAmount,
        x.accountBalance,
        x.sdaAvailable,
        x.fiaAvailable,
        x.userFiaPinsAvailableAmount,
        x.suggestedTradeFiaPinRatio,
        x.arbRate,
        x.lastTransactionDate,
        x.tradeReason,
        x.preferredMinArbRate,
        x.maxTradeAmount,
        x.spouse?.id,
        x.spouse?.fullName,
        x?.spouseAccountBalance
      );
      possibleTrades.push(possibleT);
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(possibleTrades);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename + formatDate(new Date(), 'yyyyMMdd_HHmm', 'en') + '.xlsx');
  }

  onTradeCheckboxChanged(trade: UserTradingSearchResponse) {
    //console.log("onTradeCheckboxChanged");
    if (trade.selected == false) {
      this.onTradeChecked(trade);
    } else {
      this.onTradeUnchecked(trade);
    }
  }

  openModal() {
    //console.log("openModal");
    this.modalBusy = false;
    this.userFiaPinModal.show();
  }

  closeModal() {
    //console.log("closeModal");
    this.modalBusy = true;
    this.unselectTrade();
    this.userFiaPinModal.hide();
    this.warningsAcknowledged = false;
  }

  allWarningsAcknowledged() {
    this.warningsAcknowledged = true;
  }
  notAllWarningsAcknowledged() {
    this.warningsAcknowledged = false;
  }

  hasWarnings() {
    return this.selectedTrade.warnings.length > 0;
  }

  hasPossibleDepositWarning(warnings: Reason[]) {
    if (warnings.length > 0) {
      return warnings.some((warning) => warning.title.includes('Possible Deposit'));
    }

    return false;
  }

  onTradeChecked(trade: UserTradingSearchResponse) {
    //console.log("onTradeChecked");
    this.selectTrade(trade);
    // TODO: LDF look at this method, make it async
    //this.GetSelectedTradeUserLatestLargestBankBalance();
    this.prePopulateTrade();
    this.openModal();
  }

  loadExistingNewTransactionIntoSelectedTrade() {
    //console.log("loadTrade");
    var existingNewTransaction = this.findCorrespondingNewTransactionToProcess(this.selectedTrade.userId);
    if (existingNewTransaction == null) {
      console.error('Failed to load existing transaction');
    } else {
      //console.log('overwriting sda ' + this.selectedTrade.sdaAmount + ' with ' + existingNewTransaction.sdaAmount);
      this.selectedTrade.sdaAmount = existingNewTransaction.sdaAmount;
      if (existingNewTransaction.userFiaPins.length > 0) {
        existingNewTransaction.userFiaPins.forEach((pin) => {
          //console.log('overwriting pin amount with ' + pin.transactionUsedAmount);
          this.updatePinUsedAmount(pin.id, pin.transactionUsedAmount, true);
        });
      } else {
        //console.log('no pins found');
      }
      console.log(
        'overwriting acc bal ' + this.selectedTrade.overriddenAccountBalance + ' with ' + existingNewTransaction.overriddenAccountBalance
      );
      this.selectedTrade.overriddenAccountBalance = existingNewTransaction.overriddenAccountBalance;
      this.selectedTrade.overrideAccountBalance = existingNewTransaction.overrideAccountBalance;
      this.selectedTrade.overridePips = existingNewTransaction.overridePips;
      this.selectedTrade.pips = existingNewTransaction.pips;
      this.selectedTrade.billingPlanType = existingNewTransaction.selectedBillingType;
    }
    this.updateTotals();
  }

  onTradeUnchecked(trade: UserTradingSearchResponse) {
    //console.log("onTradeUnchecked");
    this.removeCorrespondingNewTransactionToProcess(trade.userId);
    this.resetCorrespondingUserResponse(trade.userId);
    this.resetSelectedTrade();
    this.unselectTrade();
    this.updateGrandTotal();
  }

  selectTrade(trade: UserTradingSearchResponse) {
    //console.log("selectTrade");
    this.selectedTrade = trade;
    this.updateTotals();
  }

  unselectTrade(deselectCheckbox: boolean = false) {
    //console.log("unselectTrade");
    if (deselectCheckbox) {
      this.selectedTrade.selected = false;
    }
    this.selectedTrade = new UserTradingSearchResponse();

    this.updateTotals();
  }

  resetSelectedTrade() {
    //console.log("resetSelectedTrade");
    this.selectedTrade.overrideAccountBalance = false;
    this.selectedTrade.overriddenAccountBalance = 0;
    this.selectedTrade.sdaAmount = 0;
    this.selectedTrade.userFiaPins.forEach((pin) => {
      pin.transactionUsedAmount = 0;
    });
  }

  onTradeEditClicked(trade: UserTradingSearchResponse) {
    //console.log("onTradeEditClicked");
    this.selectTrade(trade);
    this.loadExistingNewTransactionIntoSelectedTrade();
    this.openModal();
  }

  onTradeSaveClick() {
    //console.log("onTradeSaveClicked");

    var existingNewTransaction = this.findCorrespondingNewTransactionToProcess(this.selectedTrade.userId);
    if (existingNewTransaction == null) {
      existingNewTransaction = this.generateNewTransactionFromSelectedTrade();
    }
    this.saveNewTransaction(existingNewTransaction);
    this.updateSuggestedTradeAmount(this.selectedTrade.userId, existingNewTransaction.tradeAmount);
    this.unselectTrade();
    this.closeModal();
    this.updateGrandTotal();
  }

  onTradeCloseClick() {
    //console.log("onTradeCloseClicked");

    if (this.isEditMode() == false) {
      this.unselectTrade(true);

      this.resetCorrespondingUserResponse(this.selectedTrade.userId);
      this.resetSelectedTrade();
    } else {
      // we don't save cos it's like cancel??
      // however the objects are already bound so still "saves" the changes anyway
      // but at least the seperate object for tradesToProcess are still left as is
      this.unselectTrade();
    }
    this.closeModal();
  }

  prePopulateTrade() {
    //console.log("prePopulateTrade");
    this.fillAllPins();
    this.fillSdaAmount();
  }

  fillAllPins() {
    //console.log("fillAllPins");
    if (this.selectedTrade.fiaAvailable <= 0) {
      return;
    }
    if (this.selectedTrade.userFiaPins.length <= 0) {
      return;
    }
    let fiaRemaining = this.selectedTrade.fiaAvailable;
    //console.log('fiaRemaining', fiaRemaining);
    this.selectedTrade.userFiaPins.forEach((pin) => {
      //console.log(pin.transactionUsedAmount);
      this.fillPin(pin, fiaRemaining);
      //console.log(pin.transactionUsedAmount);
      fiaRemaining -= pin.transactionUsedAmount;

      if (fiaRemaining <= 0) {
        return;
      }
    });
  }

  calculatePinAmountToBeUsed(pin: UserFiaPins, fiaRemaining: number) {
    //console.log('calculatePinAmountToBeUsed');
    if (fiaRemaining <= 0) {
      return 0;
    }

    let suggestedPinAmount = this.CalculateRemainingAmountFromSuggested();
    if (suggestedPinAmount > fiaRemaining) {
      suggestedPinAmount = fiaRemaining;
    }

    if (suggestedPinAmount > pin.pinBalance) {
      suggestedPinAmount = pin.pinBalance;
    }

    return suggestedPinAmount;
  }

  fillPin(pin: UserFiaPins, fiaRemaining: number) {
    //console.log("fillPin");
    var newAmount = this.calculatePinAmountToBeUsed(pin, fiaRemaining);

    this.updatePinUsedAmount(pin.id, newAmount);
    this.updateTotals();
  }

  updatePinUsedAmount(pinId: number, newAmount: number, overwriteAmount: boolean = false) {
    //console.log("updatePinUsedAmount");
    var selectedPinIndex = this.selectedTrade.userFiaPins.findIndex((x) => x.id == pinId);
    if (selectedPinIndex != -1) {
      if (overwriteAmount || this.selectedTrade.userFiaPins[selectedPinIndex].transactionUsedAmount <= 0) {
        //console.log('overwriting pin used: ' + newAmount);
        this.selectedTrade.userFiaPins[selectedPinIndex].transactionUsedAmount = newAmount;
      } else {
        //console.log('pin already has amount used: ' + this.selectedTrade.userFiaPins[selectedPinIndex].transactionUsedAmount);
      }
    } else {
      //console.log('couldnt find pin id ' + pinId);
    }
  }

  clearPin(pin: UserFiaPins) {
    //console.log("clearPin");
    var selectedPinIndex = this.selectedTrade.userFiaPins.findIndex((x) => x.id == pin.id);

    if (selectedPinIndex != -1) {
      this.selectedTrade.userFiaPins[selectedPinIndex].transactionUsedAmount = 0;
    }

    this.updateTotals();
  }

  isAnyPinUsedAmountNegativeOrOverPinValue(): boolean {
    if (this.selectedTrade.userFiaPins.length > 0) {
      return this.selectedTrade.userFiaPins.some((pin) => {
        if (pin.transactionUsedAmount < 0) {
          return true;
        }

        if (pin.pinBalance < pin.transactionUsedAmount) {
          return true;
        }
      });
    }

    return false;
  }

  fillSdaAmount() {
    //console.log("fillSdaAmount");
    if (this.selectedTrade.sdaAmount <= 0) {
      var newSda = this.CalculateRemainingAmountFromSuggested();
      if (newSda > this.CalculateBankBalance()) {
        newSda = this.CalculateBankBalance();
      }
      if (newSda > this.selectedTrade.sdaAvailable) {
        newSda = this.selectedTrade.sdaAvailable;
      }

      if (this.CalculateRemainingAmountFromSuggested() > this.selectedTrade.sdaAvailable) {
        this.selectedTrade.sdaAmount = this.selectedTrade.sdaAvailable;
      } else {
        this.selectedTrade.sdaAmount = this.CalculateRemainingAmountFromSuggested();
      }
    } else {
      //console.log('Sda already filled: ' + this.selectedTrade.sdaAmount);
    }

    this.updateTotals();
  }

  clearSda() {
    //console.log("clearSda");
    this.selectedTrade.sdaAmount = 0;

    this.updateTotals();
  }

  isEditMode() {
    return this.findCorrespondingNewTransactionToProcess(this.selectedTrade.userId) != null;
  }

  findCorrespondingNewTransactionToProcess(tradeUserId: number): NewTransaction {
    var tradeToEditIndex = this.tradesToProcess.findIndex((x) => x.userId == tradeUserId);
    if (tradeToEditIndex != -1) {
      return this.tradesToProcess[tradeToEditIndex];
    }

    return null;
  }

  doesCurrentTradeDeviateFromLastTrade(deviationThreshold: number): boolean {
    if (this.selectedTrade.lastTransactionAmount > this.selectedTradeTotalAmount) {
      //We only want the highlight if the deviation is above the last transaction by the threshold amount
      return false;
    }
    const difference = this.selectedTrade.lastTransactionAmount - this.selectedTradeTotalAmount;

    //Absolute difference (either pos or neg) has deviated by the deviationThreshold
    if (Math.abs(difference) >= deviationThreshold) {
      return true;
    }
    return false;
  }

  resetCorrespondingUserResponse(tradeUserId: number) {
    //console.log("resetCorrespondingUserResponse");
    var index = this.userTradingSearchResponse.findIndex((x) => x.userId == tradeUserId);
    if (index != -1) {
      this.userTradingSearchResponse[index].overriddenAccountBalance = 0;
      this.userTradingSearchResponse[index].overrideAccountBalance = false;
      this.userTradingSearchResponse[index].sdaAmount = 0;
      this.userTradingSearchResponse[index].userFiaPins.forEach((pin) => {
        pin.transactionUsedAmount = 0;
      });
    }
  }

  updateSuggestedTradeAmount(tradeUserId: number, newTotal: number) {
    var index = this.userTradingSearchResponse.findIndex((x) => x.userId == tradeUserId);
    if (index != -1) {
      this.userTradingSearchResponse[index].suggestedTradeAmount = newTotal;
    }
  }

  removeCorrespondingNewTransactionToProcess(tradeUserId: number) {
    //console.log("removeCorrespondingNewTransactionToProcess");
    var tradeToEditIndex = this.tradesToProcess.findIndex((x) => x.userId == tradeUserId);
    if (tradeToEditIndex != -1) {
      this.tradesToProcess.splice(tradeToEditIndex, 1);
      if (this.tradesToProcess.length == 0) {
        this.tradesToProcess = [];
      }
    }
  }

  updateTotals() {
    //console.log("updateTotals");
    this.selectedTradeAmountRemaining = this.CalculateRemainingAmountFromSuggested();
    this.selectedTradeTotalAmount = this.CalculateTotalTradeAmount();

    this.ValidateTradeBreakdown(this.selectedTrade);
  }

  updateGrandTotal() {
    //console.log("updateGrandTotal");
    this.totalTradesValue = 0;
    this.arbFacilitatorAvailableBalanceRemaining = this.arbFacilitatorAvailableBalance;

    this.tradesToProcess.forEach((x) => {
      this.totalTradesValue += x.tradeAmount;
      this.arbFacilitatorAvailableBalanceRemaining -= x.tradeAmount;
    });
  }

  CalculateBankBalance() {
    //console.log("CalculateBankBalance");
    if (this.selectedTrade.overriddenAccountBalance > 0 || this.selectedTrade.overrideAccountBalance) {
      return this.selectedTrade.overriddenAccountBalance;
    }

    return this.selectedTrade.accountBalance;
  }

  CalculateRemainingAmountFromSuggested() {
    //console.log("CalculateRemainingAmountFromSuggested");
    var remaining = this.selectedTrade.suggestedTradeAmount - this.CalculateTotalTradeAmount();
    return remaining;
  }

  CalculateTotalTradeAmount() {
    //console.log("CalculateTotalTradeAmount");
    var total = this.selectedTrade.sdaAmount + this.CalculateFiaAmount();
    return total;
  }

  CalculateFiaAmount() {
    //console.log("CalculateFiaAmount");
    if (this.selectedTrade.userFiaPins.length >= 1) {
      this.InitializePins();
      var fiaAmount = this.selectedTrade.userFiaPins.reduce((sum: number, b: UserFiaPins) => sum + b.transactionUsedAmount, 0);
      return fiaAmount;
    }

    return 0;
  }

  InitializePins() {
    this.selectedTrade.userFiaPins.forEach((x) => {
      if (x.transactionUsedAmount == null || x.transactionUsedAmount == undefined) {
        x.transactionUsedAmount = 0;
      }
    });
  }

  ShowModal(user: UserTradingSearchResponse, Modal: string) {
    this.modalBusy = true;
    if (Modal == 'userInfoModal') {
      user.profileIsLoading = true;
      this.GetUserFullDetails(user.userId).then(() => {
        this.showUserProfileModal = true;
        user.profileIsLoading = false;
      });
    }
    this.modalBusy = false;
  }

  GetUserFullDetails(userId: number) {
    return new Promise((resolve) => {
      this.modalBusy = true;
      this.userService.GetUserDetails(userId, true).subscribe({
        next: (fullDetails: UserFullDetails) => {
          this.selectedUserFullDetails = fullDetails;
          this.selectedUserProfile = fullDetails.profile;
          this.modalBusy = false;
          this.showError = false;
          resolve(true);
        },
        error: (err) => {
          this.parseAndDisplayError(err);
          resolve(true);
        },
      });
    });
  }

  private subscribeToTagsRefreshStream() {
    this.tagService.refreshNeeded$.subscribe((userId) => {
      this.tagService.GetUserTags(userId, true).subscribe({
        next: (userTags: Tag[]) => {
          this.updateTagsForUser(userTags, userId);
        },
        error: (error) => {
          this.errorMsg = Error.InterpretErrorMessage(error);
          this.showError = true;
        },
      });
    });
  }

  private updateTagsForUser(updatedTags: Tag[], userId: number) {
    const foundIndex = this.userTradingSearchResponse.findIndex((x) => x.userId === userId);

    this.userTradingSearchResponse[foundIndex].tags = updatedTags;
  }

  public filteredWarnings(warnings: Reason[]): Reason[] {
    let filteredList: Reason[] = [];
    warnings.forEach((warning) => {
      if (warning.onlyDisplayInsideTradeEdit == false) {
        filteredList.push(warning);
      }
    });
    return filteredList;
  }

  parseAndDisplayError(error: any) {
    this.errorMsg = Error.InterpretErrorMessage(error);
    this.showError = true;
    this.modalBusy = false;
  }

  showPinsAsText(pins: UserFiaPins[]): string {
    if (!pins || pins?.length == 0) {
      return '';
    }

    const onlyUsedPins = pins.filter((pin) => pin.transactionUsedAmount > 0);

    return onlyUsedPins.map((pin) => `${pin.pin}: ${pin.transactionUsedAmount}`).join(' ');
  }

  shouldShowBadge(trade: PrebookingTrade): boolean {
    return trade?.message?.toLowerCase().includes('caution');
  }

  stripCaution(message: string): string {
    return message?.replace('CAUTION', '').trim();
  }

  isBelowBookingLimit(): boolean {
    const bookingLimit = 1000;
    return this.tradesToProcess.length < bookingLimit;
  }

  protected busyWithCFSChecks: boolean = false;
  protected showCFSCheckError: boolean = false;
  protected cfsChecksErrorMessage: string = '';
  protected showSendCFSButton: boolean = false;
  protected showSendCodeButton: boolean = false;
  protected CFSCode: string = '';
  protected cfsChecksComplete: boolean = false;
  protected cfsCheckCompletedDate: Date = null;

  showCFSReadyStep(): boolean {
    if (this.busyWithCFSChecks) {
      return false;
    }

    if (this.cfsChecksComplete) {
      return false;
    }

    return this.showSendCFSButton;
  }

  showCFSCodeStep(): boolean {
    if (this.busyWithCFSChecks) {
      return false;
    }

    if (this.cfsChecksComplete) {
      return false;
    }

    return this.showSendCodeButton;
  }

  showCFSCompleteStep(): boolean {
    if (this.busyWithCFSChecks) {
      return false;
    }

    return !this.showCFSReadyStep() && !this.showCFSCodeStep();
  }

  DisplayCFSCheckDialog() {
    this.showCFSCheckError = false;
    this.showSendCFSButton = true;
    this.showSendCodeButton = false;
    this.cfsCheckClients.show();
  }

  CFSChecksClose() {
    this.cfsCheckClients.hide();
  }

  SendClientIDs() {
    this.showCFSCheckError = false;
    this.cfsChecksErrorMessage = '';

    this.busyWithCFSChecks = true;

    const actionByUserId = this.settingsService.user.id;
    this.userService.SendIDNumbersForCFSClientCheck(this.userIdList, actionByUserId).subscribe({
      next: () => {
        this.busyWithCFSChecks = false;

        this.showSendCFSButton = false;
        this.showSendCodeButton = true;
      },
      error: (err) => {
        this.busyWithCFSChecks = false;

        this.showCFSCheckError = true;
        this.cfsChecksErrorMessage = Error.InterpretErrorMessage(err);
      },
    });
  }

  SubmitCFSCode() {
    this.showCFSCheckError = false;
    this.cfsChecksErrorMessage = '';

    this.busyWithCFSChecks = true;
    const actionByUserId = this.settingsService.user.id;
    this.userService.SendCFSCode(this.CFSCode, actionByUserId).subscribe({
      next: () => {
        this.busyWithCFSChecks = false;

        this.showSendCodeButton = false;
        this.showSendCFSButton = false;
        this.cfsChecksComplete = true;
        this.cfsCheckCompletedDate = new Date();
      },
      error: (err) => {
        this.busyWithCFSChecks = false;

        this.showCFSCheckError = true;
        this.cfsChecksErrorMessage = Error.InterpretErrorMessage(err);
      },
    });
  }

  trackById(index: number, item: any) {
    return item?.id || index;
  }
}
